import React, { FC } from 'react';
import CustomAutocomplete from '../../CustomAutocomplete';
import useTranslation from '../../../hooks/useTranslation';
import { BuInputProps } from './BuInputProps';
import { useFormContext } from 'react-hook-form';
import { getUnitCategory } from './utlis';

const BUInput: FC<BuInputProps> = ({
  BuList,
  onBUChange,
  required,
  disabled,
  isEdit,
}) => {
  const t = useTranslation();
  const { setValue, getValues } = useFormContext();
  const businessUnitId = getValues('businessUnitId');

  return (
    <>
      {BuList?.length >= 0 && (
        <>
          <CustomAutocomplete
            optionsArray={BuList}
            name={'businessUnitId'}
            label={t('labels.businessUnitId')}
            customOnChange={(e) => {
              if (onBUChange) {
                onBUChange(e as Event);
              }
              if (!isEdit) {
                setValue('unitCategory', getUnitCategory(e.businessUnitId), {
                  shouldValidate: true,
                  shouldDirty: true,
                });
                setValue('unitType', null);
              }
            }}
            required={required}
            disabled={disabled && businessUnitId}
          />
        </>
      )}
    </>
  );
};

export default BUInput;
